function toggleLoginModal(context) {
  context.commit("toggleLoginModal");
}
function closeRedirectModal(context) {
  context.commit("closeRedirectModal");
}
function setModalType(context, type) {
  context.commit("setModalType", type);
}
function setTopNumber(context, number) {
  context.commit("setTopNumber", number);
}
function setPolskiTopWszech(context, number) {
  context.commit("setPolskiTopWszech", number);
}
function setGenericModalText(context, text) {
  context.commit("setGenericModalText", text);
}
function setSearchQuery(context, text) {
  context.commit("setSearchQuery", text);
}
function setSearchCategory(context, text) {
  context.commit("setSearchCategory", text);
}
function setLogInFlag(context, setting) {
  context.commit("setLogInFlag", setting);
}
function selectNote(context, note) {
  context.commit("selectNote", note);
}
function toggleSearch(context, note) {
  context.commit("toggleSearch", note);
}
function setCurrentListId(context, number) {
  context.commit("setCurrentListId", number);
}
export default {
  toggleLoginModal,
  setModalType,
  setTopNumber,
  setPolskiTopWszech,
  setGenericModalText,
  setSearchQuery,
  setSearchCategory,
  setLogInFlag,
  selectNote,
  toggleSearch,
  setCurrentListId,
  closeRedirectModal,
};
